// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__377co","delete":"Button_delete__10Lue","spinning":"Button_spinning__1PqCu","spinner":"Button_spinner___eYt1"};